import shouldUpdate from "./shouldUpdate";
import shallowEqual from "./utils/shallowEqual";
export var pure = shouldUpdate(function (prev, next) {
  return !shallowEqual(prev, next);
});
export default pure;